import React from 'react';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-cta">
      Узнайте, какие данные мы можем найти <br />
      <span className="footer-gradient">именно для вас</span>
    </div>
    <div className="footer-copyright text-center">
      © 2026 datacircle. Все права защищены<br />
      ООО "Заря Венчурс"
    </div>
  </footer>
);

export default Footer; 